import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { City, Region } from "../types/regions";

export type UserSettingsSlice = {
  // plainPayload is unused
  plainPayload: Record<string, any>;
  defaultRegionId: number | null;
  defaultCityId: number | null;
  defaultRegion: Region | null;
  defaultCity: City | null;
};

const initialState: UserSettingsSlice = {
  plainPayload: {},
  defaultRegionId: null,
  defaultCityId: null,
  defaultRegion: null,
  defaultCity: null
};

const userSettingsSlice = createSlice({
  name: "userSettings",
  initialState,
  reducers: {
    setUserSettings(
      state,
      action: PayloadAction<{
        defaultRegionId: number;
        defaultCityId: number;
        defaultRegion: Region;
        defaultCity: City;
      }>
    ) {
      state.plainPayload = action.payload;
      state.defaultRegionId = action.payload.defaultRegionId;
      state.defaultCityId = action.payload.defaultCityId;
      state.defaultRegion = action.payload.defaultRegion;
      state.defaultCity = action.payload.defaultCity;
    }
  }
});

export const { setUserSettings } = userSettingsSlice.actions;

export default userSettingsSlice.reducer;
